import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "隐私条款" }) => {
    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <ContentWithPaddingXl>
                    <HeadingRow>
                        <Heading>{headingText}</Heading>
                    </HeadingRow>
                    <Text>
                        <p>生效日期： 2024 年 3 月 1 日</p>
                        <p> 欢迎来到红隼游戏！红隼公司致力于保护您的个人信息和隐私。本隐私政策协议将解释我们如何在您使用红隼公司的所有游戏时收集、使用和保护您提供给我们的信息。请在使用我们的服务之前仔细阅读此协议。 </p> <p> 我们使用您的个人数据来提供和改进服务。通过使用本服务，您同意根据本隐私政策收集和使用信息。 </p> <p> 感谢您玩我们的游戏！本隐私政策描述了： </p> <ul> <li> <p> 我们如何收集您的个人数据以及我们这样做的原因 </p> </li> <li> <p> 我们如何使用您的个人数据 </p> </li> <li> 您对个人数据拥有的选择权。 </li> </ul> <p> 本隐私政策适用于红隼的游戏、商店、网站和相关服务，我们统称为“服务”。我们可能会通过在 falcon-games.com 上发布新版本定期更新本隐私政策。如果我们做出任何重大更改，我们将在变更生效前在服务中发布通知，告知您这些更改。您在变更生效日期之后继续使用服务，将受新的隐私政策的约束。 </p>  <h2>我们收集的数据</h2> <p> 我们收集的个人数据类别取决于您使用的服务以及适用法律的要求。 </p> <p> 您直接提供给我们的数据。 </p> <p> ▪ 联系信息（例如电子邮件地址） </p> <p> ▪ 玩家名称或 ID 及密码 </p> <p> ▪ 个人资料信息（例如个人资料照片） </p> <p> ▪ 您在使用服务时提交的消息和其他内容（例如聊天记录和玩家支持工单） </p> <p> ▪ 您在参与调查、促销、抽奖、比赛和其他活动时提供的数据 </p> <p> ▪ 我们的支付服务提供商将在您通过红隼商店进行购买时收集您的支付详情 </p> <h2>我们自动收集的数据</h2> <p> ▪ 有关您的账户和游戏进度的数据，包括在大多数情况下自动创建的内部账户 ID </p> <p> ▪ 您的 IP 地址和移动设备标识符（如设备 ID 或广告 ID） </p> <p> ▪ 有关您设备的数据，例如设备名称和操作系统、浏览器类型和语言、互联网服务提供商和移动运营商 </p> <p> ▪ 我们通过 Cookie 和类似技术收集的数据（见下文） </p> <p> ▪ 大致位置信息（由 IP 地址推断） </p> <p> ▪ 您使用服务的相关数据，例如游戏数据、购买记录以及您与其他玩家在服务中的互动 </p> <p> 您还可以选择使用您的电子邮件地址或其他联系信息创建红隼 ID。 </p> <h2>我们从合作伙伴处收集的数据</h2> <p> 我们还使用第三方合作伙伴，例如社交网络网站、数据分析提供商和广告网络来补充我们对您的信息，如： </p> <p> ▪ 如果您将第三方工具与服务关联（如某些市场中的 LINE、微信或 Meta），我们接收的数据 </p> <p> ▪ 人口统计数据（例如根据您的 IP 地址确定的大致位置） </p> <p> ▪ 用于打击欺诈的数据（如游戏中的退款滥用或广告中的点击欺诈） </p> <p> ▪ 游戏运行平台或支付服务提供商提供的数据（如支付验证数据） </p> <p> ▪ 用于广告和分析的数据（如调查），以便我们为您提供更好的服务 </p> <p> ▪ 您通过隐私设置从第三方服务（如某些市场中的 LINE、微信或 Meta）向我们提供的数据 </p> <h2>我们为何收集您的数据</h2> <p> 我们使用您的数据进行多种业务用途，例如： </p> <p> 使服务正常运作。 </p> <p> 为履行合同，我们处理必要的数据以： </p> <p> ▪ 创建账户并允许您玩我们的游戏并使用我们的服务 </p> <p> ▪ 运营服务 </p> <p> ▪ 验证和确认付款 </p> <p> ▪ 提供和交付您请求的产品和服务 </p> <p> ▪ 向您发送服务相关的通讯 </p> <h2>让服务更适合我们的玩家</h2> <p> 为向玩家提供优质服务，我们有合法利益收集和处理必要数据以： </p> <p> ▪ 更新和开发玩家资料 </p> <p> ▪ 开发和改进服务和玩家体验 </p> <p> ▪ 管理我们与您的关系 </p> <p> ▪ 提供社交功能作为服务的一部分 </p> <p> ▪ 定制您的服务体验 </p> <p> ▪ 回应您的评论和问题并提供玩家支持 </p> <p> ▪ 在服务中以及其他网站和服务（包括电子邮件）向您提供红隼的优惠 </p> <p> ▪ 向您发送相关信息，如更新、安全提醒和支持消息 </p> <p> ▪ 使您能够与其他玩家进行交流 </p>
                        <h2>显示个性化广告</h2>
                        <p>
                            为了在服务中和其他地方（包括电子邮件）向您展示个性化广告，我们有合法利益处理必要的数据以：
                        </p>

                        <p>
                            ▪ 跟踪您在使用服务时访问的内容以及您的在线行为
                        </p>

                        <p>
                            ▪ 提供、定位和改进我们的广告和服务
                        </p>

                        <h2>保持服务安全公平</h2>
                        <p>
                            确保服务的公平性是我们的首要任务。更多信息请参见我们的《红隼服务条款》。
                        </p>

                        <p>
                            为了保持服务及其社交功能的安全和公平，打击欺诈行为并确保其他合理使用，我们有合法利益处理必要数据以：
                        </p>

                        <p>
                            ▪ 分析和监控服务及其社交功能的使用情况
                        </p>

                        <p>
                            ▪ 自动或手动审核聊天内容
                        </p>

                        <p>
                            ▪ 针对欺诈或不良行为的玩家采取措施
                        </p>

                        <h2>进行分析、画像和分段</h2>
                        <p>
                            在上述所有情况和目的中，我们可能会对所有收集的数据进行分析、画像和分段。
                        </p>

                        <h2>在您的同意下</h2>
                        <p>
                            在您的同意下，我们可能会出于其他目的处理您的数据。
                        </p>

                        <p>
                            我们还可能收集并使用您的设备标识符以展示并个性化游戏内广告，并提供定向行为广告，如下所述。根据适用的隐私法律，包括《通用数据保护条例》（GDPR），我们需要征得您的同意才能这样做。
                        </p>

                        <p>
                            这些数据是在您同意的情况下共享的，以便我们的广告合作伙伴能够提供合适的广告并优化广告内容，确保您不会重复看到同一广告。我们将您的设备标识符与选定的合作伙伴共享，以便进行广告投放和个性化设置。
                        </p>

                        <p>
                            您可以在游戏设置中管理您的同意，并在设备设置中限制广告跟踪。请注意，选择退出广告跟踪是特定于每个浏览器和设备的，可能需要一些时间才能生效。
                        </p>

                        <p>
                            对于应用中的移动广告，您可以重置您的广告标识符，并根据您的设备选择退出基于兴趣的广告（Android）或打开“限制广告跟踪”设置（iOS）。
                        </p>

                        <p>
                            合作伙伴运营广告网络和中介平台，参与广告库存竞价。合作伙伴还可能基于其合法利益使用设备标识符进行欺诈检测。更多信息请查看合作伙伴的隐私政策。
                        </p>

                        <p>
                            ironSource隐私政策：<a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1" target="_blank" rel="noopener noreferrer">https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/#step-1</a>
                        </p>

                        <p>
                            Vungle隐私政策：<a href="https://vungle.com/privacy/" target="_blank" rel="noopener noreferrer">https://vungle.com/privacy/</a>
                        </p>

                        <p>
                            Google隐私政策：<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
                        </p>

                        <p>
                            Liftoff隐私政策：<a href="https://liftoff.io/privacy-policy/" target="_blank" rel="noopener noreferrer">https://liftoff.io/privacy-policy/</a>
                        </p>

                        <p>
                            Mintegral隐私政策：<a href="https://www.mintegral.com/en/privacy" target="_blank" rel="noopener noreferrer">https://www.mintegral.com/en/privacy</a>
                        </p>

                        <p>
                            Unity Ads隐私政策：<a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://unity.com/legal/privacy-policy</a>
                        </p>

                        <p>
                            Facebook隐私政策：<a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/</a>
                        </p>

                        <p>
                            Apple搜索广告隐私政策：<a href="https://searchads.apple.com/privacy" target="_blank" rel="noopener noreferrer">https://searchads.apple.com/privacy</a>
                        </p>

                        <p>
                            Applovin隐私政策：<a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.applovin.com/privacy/</a>
                        </p>

                        <p>
                            inMobi隐私政策：<a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer">https://advertising.inmobi.com/privacy-policy</a>
                        </p>

                        <p>
                            Pangle隐私政策：<a href="https://www.pangleglobal.com/zh/privacy" target="_blank" rel="noopener noreferrer">https://www.pangleglobal.com/zh/privacy</a>
                        </p>

                        <p>
                            DT Exchange隐私政策：<a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.digitalturbine.com/legal/privacy-policy</a>
                        </p>

                        <p>
                            Chartboost隐私政策：<a href="https://docs.chartboost.com/en/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://docs.chartboost.com/en/legal/privacy-policy</a>
                        </p>
                        <p>
                            TapSDK 隐私政策: <a href="https://www.tapdb.com/tapsdk-privacy.html" target="_blank" rel="noopener noreferrer">https://www.tapdb.com/tapsdk-privacy.html</a>
                        </p>
                        <p>
                            talkingdata 隐私政策: <a href="https://www.talkingdata.com/privacy.jsp" target="_blank" rel="noopener noreferrer">https://www.talkingdata.com/privacy.jsp</a>
                        </p>

                        <h2>谁能看到您的数据</h2>
                        <p>
                            除了红隼外，其他人在以下情况下可以访问您的数据：
                        </p>

                        <p>
                            其他玩家和用户。
                        </p>

                        <p>
                            社交功能是我们游戏的核心组成部分。其他玩家和用户可能会看到您的个人资料数据、游戏内活动，并阅读您发布的消息。
                        </p>

                        <p>
                            我们的服务提供商。
                        </p>

                        <p>
                            红隼拥有帮助我们提供服务的供应商。这些供应商仅按照红隼的指示处理您的数据，以提供服务并执行诸如托管、玩家支持、广告、分析和防欺诈等任务。
                        </p>

                        <p>
                            其他公司和公共机构。
                        </p>

                        <p>
                            为了验证付款（与支付提供商如 PayPal）并打击欺诈和非法活动，我们可能会处理和披露数据与其他公司和组织共享，并应法律要求向公共机构提供。
                        </p>

                        <p>
                            我们还可能基于您的同意披露您的数据，遵守法律，或保护我们、我们的玩家或其他人的权利、财产或安全。
                        </p>

                        <p>
                            广告和社交媒体合作伙伴。
                        </p>

                        <p>
                            服务包含我们合作伙伴的功能，如社交媒体互动工具、通过应用编程接口（API）或软件开发工具包（SDK）的功能，以及游戏内广告。在“根据您的同意”部分列出了这些合作伙伴。这些合作伙伴可能会访问您的数据，并根据他们的隐私政策操作。我们鼓励您查看他们的隐私政策，了解更多他们的数据处理实践。
                        </p>

                        <p>
                            这些合作伙伴可能会访问有关您活动和设备的数据（如您的 IP 地址、移动设备标识符、访问的页面、位置、时间）。我们也可能会将我们收集到的关于您的数据与第三方广告合作伙伴共享。这些广告合作伙伴可能会将这些数据（以及从其他服务收集的类似数据）用于在他们的网络内向您投放定向广告。这些合作伙伴可能根据他们的隐私政策操作。这种做法通常被称为“基于兴趣的广告”或“在线行为广告”。
                        </p>

                        <h2>国际数据传输</h2>
                        <p>
                            我们的服务具有全球性，因此您的数据可能会被传输到世界各地。由于不同国家的数据保护法律可能与您所在国家的法律不同，我们会采取措施确保有适当的保障措施来保护您的数据，如本隐私政策中所述。我们可能会使用的适当保障措施包括欧盟委员会批准的标准合同条款以及其他合法的保障措施。
                        </p>

                        <h2>您的权利与选择</h2>
                        <p>
                            取消订阅营销电子邮件和其他直接营销。
                        </p>

                        <p>
                            在适用法律允许的情况下，红隼可能会基于现有的客户关系向您发送营销通讯。
                        </p>

                        <p>
                            您可以通过按照这些通讯中的说明操作或更改游戏内设置来选择不接收我们的促销通讯。更新的设置可能不会立即生效。请注意，您可能仍然会继续收到我们发送的非促销通讯，例如有关服务的通讯、我们红隼服务条款或本隐私政策的更新通知，或与您在服务中的购买相关的交易信息。
                        </p>
                        <h2>推送通知</h2> <p> 我们可能会通过我们的移动应用程序向您发送推送通知。您可以随时通过更改移动设备上的设置选择不再接收这些类型的通讯。 </p> <h2>退出定向广告</h2> <p> 您可以通过检查 Android 或 iOS 设备的隐私设置，关闭“允许应用请求跟踪”或选择“限制广告跟踪”（Apple iOS）或“退出基于兴趣的广告”（Android），退出移动应用程序中的基于兴趣的广告。您还可以通过游戏设置中提供的选项（如适用）退出个性化的游戏内优惠。 </p> <p> 访问我们持有的关于您的个人数据。 </p> <p> 如果您提出请求，我们将以电子格式向您提供一份您的个人数据副本。 </p> <h2>您的其他权利</h2> <p> 您还拥有更正数据、删除数据、反对我们如何使用或共享您的数据以及限制我们使用或共享您的数据的权利。您可以随时撤回您的同意。 </p> <p> 我们会在合理的时间内回复所有请求。如果您有任何未解决的隐私或数据使用问题，而我们未能令人满意地解决，您也可以联系欧洲经济区、瑞士或英国的当地数据保护机构，以解决未解决的投诉。 </p> <p> 如果您希望行使上述任何数据主体权利，请使用“联系我们”部分中描述的支持选项。我们将根据适用法律回复所有请求。为了保护您的隐私，我们可能还会采取其他步骤来验证您的身份，例如要求您提供购买凭证或其他账户信息，要求您将您的电子邮件地址与您的游戏账户关联（例如通过游戏 ID），或者要求您回答有关您在我们服务中的活动的问题。身份验证后，您还可以指定授权代理人代表您行使您的权利，方法是向我们的客户支持人员提供代理人的联系信息，根据适用法律的要求。 </p> <p> 您有权不因行使这些权利而受到歧视性待遇。 </p> <h1>我们如何保护您的数据</h1> <h2>安全保障</h2> <p> 为了确保玩家拥有安全的体验，我们不断开发和实施管理、技术和物理安全措施，以保护您的数据免受未经授权的访问、丢失、滥用或篡改。 </p> <h2>数据保留</h2> <p> 只要您的账户处于活跃状态或在提供服务所需的时间内，我们将保留您的数据。例如，我们可能会定期去识别未使用的游戏账户，并定期审查和去识别不必要的数据。 </p> <p> 请注意，如果您要求我们删除您的个人数据，我们将根据我们的合法商业利益保留您的数据，例如履行我们的法律义务、解决争议并执行我们的协议。 </p> <h1>儿童隐私</h1> <p> 保护儿童的在线隐私对我们来说非常重要。通常，我们的服务并非专为13岁以下的儿童（或当地法律要求的其他年龄）设计，服务也不会有意收集儿童的个人数据，除非以下段落中所述。 </p> <p> 对于那些未专为儿童设计但可能吸引儿童的游戏，我们采取了额外措施根据玩家的年龄限制访问这些服务。对于这些服务，当玩家表明其年龄在13岁以下（或其所在地区的适用年龄）时，我们将限制他们访问某些功能，如社交媒体和聊天功能，以及某些类型的通知警报。我们还会将个人数据的处理限制在支持我们服务内部运营所必需的范围内。 </p> <p> 请注意，对于我们的某些服务，我们可能会使用比上述段落更高的年龄限制（例如16岁）。我们这样做是为了为玩家提供安全的游戏体验，并保护年轻玩家。 </p> <p> 如果您是家长或监护人，想要查看我们从您的孩子那里收集的个人数据，或希望修改或删除这些信息，您可以通过上文描述的方式与我们联系。如果我们发现儿童违反上述规定向我们提供了个人数据，我们将删除我们所收集的任何个人数据，除非我们有法律义务保留这些数据，并终止该儿童的账户和/或将其转换为未成年体验模式（如适用）。 </p> <h1>加州居民权利</h1> <p> 以下部分仅适用于加利福尼亚州居民。 </p> <h2>1) 数据收集</h2> <p> 我们在过去12个月内收集的个人数据类别及其来源已在“我们收集的数据”部分中描述。 </p> <h2>2) 数据使用</h2> <p> 我们收集您个人数据的商业或业务目的已在“我们为何收集您的数据”部分中描述。 </p> <h2>3) 数据披露和/或出售</h2> <p> 我们不会像大多数人理解的那样“出售”您的个人数据给第三方。但是，我们可能会与第三方广告平台共享您的 Cookie 信息和广告标识符，以提供基于兴趣的广告、归因安装和优化广告活动。如果这种做法在《加州消费者隐私法》（CCPA）下被视为“销售”，您可以按照“退出定向广告”部分中描述的步骤，选择退出这种共享。 </p> <p> 我们没有实际了解到任何16岁以下未成年人个人数据的出售行为，正如 CCPA 中“出售”一词的定义所述。 </p> <p> 在过去的12个月内，作为我们服务的一部分，我们已披露了以下类别的个人数据：</p>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>收集的个人数据类别</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>Red Falcon 收集的数据示例</th>
                                    <th style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold", textAlign: "center" }}>可能出于业务目的接收个人数据的第三方类别</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>标识符</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>真实姓名、别名、唯一个人标识符、在线标识符、互联网协议地址、电子邮件地址、账户名称或其他类似标识符。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>其他玩家(仅用户名和个人资料)、服务提供商、业务合作伙伴、广告网络(仅广告标识符和IP地址)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>加州客户记录法案(Cal. Civ. Code § 1798.80(e))中列出的个人数据类别</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>姓名或电话号码。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服务提供商</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>加州或联邦法律下的受保护分类特征</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>年龄。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服务提供商、广告网络(仅用于合规目的)</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>商业信息</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>购买、获得或考虑的产品或服务记录，或其他购买或消费历史或倾向。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服务提供商、广告网络</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>互联网或其他电子网络活动</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>浏览历史、消费者与互联网网站、应用程序或广告的互动信息。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服务提供商、广告网络</td>
                                </tr>
                                <tr>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>从其他个人数据推断出的消费者档案</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>反映消费者偏好、特征和行为的档案。</td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>服务提供商</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>
                            除了上述共享情况外，我们可能会将我们收集的任何关于您的信息与我们的关联公司共享，以保护我们或他人，或在合并、出售或其他资产转移的情况下共享。有关更多信息，请参阅“谁能看到您的数据”部分。
                        </p>

                        <h2>4) 您的权利</h2>
                        <p>
                            您在加利福尼亚州法律下的权利已在“您的权利和选择”部分中描述。
                        </p>

                        <h1>土耳其居民</h1>
                        <p>
                            生效日期：2022年6月1日
                        </p>
                        <p>
                            以下部分适用于位于土耳其共和国的相关数据主体。
                        </p>

                        <h2>1) 数据收集与处理</h2>
                        <p>
                            您的个人数据将根据数据保护法规，特别是土耳其《个人数据保护法》（第6698号法律“DPL”）进行处理。
                        </p>
                        <p>
                            我们收集的个人数据类别及其来源已在全球隐私政策的“我们收集的数据”部分中描述。
                        </p>
                        <p>
                            我们收集您个人数据的目的已在“我们为何收集您的数据”部分中说明。除此之外，您的个人数据将自动收集并根据《DPL》下的以下法律依据处理：
                        </p>
                        <p>
                            ▪ 第5/2(f)条
                        </p>
                        <p>
                            ▪ 第5/2(c)条
                        </p>
                        <p>
                            ▪ 第5/1条
                        </p>

                        <h2>2) 您的权利</h2>
                        <p>
                            您根据《DPL》第11条，拥有以下与我们持有的个人信息数据相关的合法权利。作为从土耳其共和国访问服务的数据主体，您可以向数据控制者申请，并在适用法律法规允许的范围内：
                        </p>
                        <p>
                            1. 了解您的个人数据是否被处理，
                        </p>
                        <p>
                            2. 要求提供有关您的个人数据是否已被处理的信息，
                        </p>
                        <p>
                            3. 了解处理您个人数据的目的以及这些个人数据是否符合目的使用，
                        </p>
                        <p>
                            4. 了解您的个人数据在国内或国外被转移至哪些第三方，
                        </p>
                        <p>
                            5. 要求更正不完整或不准确的数据（如有），
                        </p>
                        <p>
                            6. 在《DPL》第7条规定的条件下，要求删除或销毁您的个人数据，
                        </p>
                        <p>
                            7. 要求将执行的(e)和(f)项操作报告给您的个人数据被转移的第三方，
                        </p>
                        <p>
                            8. 反对通过仅自动系统处理的数据分析而对您个人产生不利结果，
                        </p>
                        <p>
                            9. 对因非法处理您的个人数据而遭受的损害提出赔偿请求。
                        </p>

                        <h2>联系我们</h2> <p> 如果您对数据保护有任何疑问，或有任何解决个人数据问题的请求，我们鼓励您通过每个红隼游戏中的支持功能与我们联系，以便我们能更快回复您。您也可以通过以下方式联系： </p> <p> 控制者名称：杭州红隼互娱文化有限公司 </p> <p> 地址：浙江省杭州市余杭区仓前街道时代天元城19幢6层601-2室 </p> <p> 收件人：隐私 </p> <p> 邮箱：support@falcon-games.com </p>

                    </Text>
                </ContentWithPaddingXl>
            </Container>
            <Footer />
        </AnimationRevealPage>
    );
};
